import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { AuthService } from './auth.service';
import * as Globals from '../common/globals';

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {



    constructor(private auth: AuthService, private router: Router) { }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // Check authentication
        if (!this.auth.getIsAuthenticated()) {
            this.router.navigate(['/login']);
            return false;
        }
        // Check authorization
        else {
            // If this component require any permissions
            if (Globals.componentsPermissions[(<any>route.component).name]) {

                // Not permmited to open this tab
                if (!this.auth.isPermmitted(Globals.componentsPermissions[(<any>route.component).name])) {

                    // Check the default tab by permmitions
                    if (this.auth.isPermmitted('RisEnterpriseManager.Tabs.MonitoringScripts')) {
                        this.router.navigate(['/shell/ris-monitoring-scripts-results']);
                    }
                    else {
                        this.router.navigate(['/shell/ris-servers-state']);
                    }
                }
            }
        }
        return true;
    }
}
